import React, { Component } from 'react';
import _ from 'lodash';

import NewTeamMemberForm from './NewTeamMemberForm';
import Subnav from '../subnav';

import withEhsPageBehavior from '../../withEhsPageBehavior';

class NewTeamMemberPage extends Component {
    render() {
        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav />
                </div>
                <div className="sidebarpage">
                    <div className="sidebarpage__content">
                        <NewTeamMemberForm
                            userId={
                                _.has(this.props, 'match.params.userId')
                                    ? this.props.match.params.userId
                                    : false
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withEhsPageBehavior(NewTeamMemberPage);
